import { gql } from "@apollo/client"

export const GET_BUSINESSES = gql`
  query GetBusinesses($businessId: ID, $companyId: ID) {
    getBusinesses(business_id: $businessId, company_id: $companyId) {
      id
      title
      balance
      credit
      total_amount
      name
      stripe_id
      client_id
    }
  }
`